import { IconProps } from '../iconProps';

export const CalendarClock = ({ size = 24, fill = '' }: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill={fill}
      stroke='currentColor'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
      className='lucide lucide-calendar-clock-icon lucide-calendar-clock'
    >
      <path d='M16 14v2.2l1.6 1' />
      <path d='M16 2v4' />
      <path d='M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5' />
      <path d='M3 10h5' />
      <path d='M8 2v4' />
      <circle
        cx='16'
        cy='16'
        r='6'
      />
    </svg>
  );
};
